import { ConclusionKeys, FindingAreasEnum, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";
import { opwPart1Q4AText } from "./AdditionalTextElements/opwPart1Question4Text";
export const questionnaireOpwPart1 = {
    id: FindingAreasEnum.OffPayrollWorkersPsc,
    name: getFindingAreaDisplayText(FindingAreasEnum.OffPayrollWorkersPsc),
    questions: [
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q1`,
            text: "Do you engage with workers on an 'off payroll' basis (this might be as self-employed individuals or via some sort of intermediary or PSC) - this includes any workers you engage with under the Construction Industry Scheme?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q2`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q2`,
            text: 'Do you engage with workers via PSC?',
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q4A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q4A`,
            text: opwPart1Q4AText,
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q5A`,
                no: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q5B`,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q5A`,
            text: "Do you have written contracts in place with the PSC?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3A`,
                no: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3B`,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q5B`,
            text: "Do you carry out formal employment status/IR35 assessments?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q6A`,
                no: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3E`,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q6A`,
            text: 'Do you issue contractors with Status Determination Statements ("SDS")?',
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3C`,
                no: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3D`,
            },
        },
        //Q3 Free text question:
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3A`,
            text: "What is your approximate spend on PSC workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3B`,
            text: "What is your approximate spend on PSC workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Red,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3C`,
            text: "What is your approximate spend on PSC workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3D`,
            text: "What is your approximate spend on PSC workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Amber,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersPsc}:Q3E`,
            text: "What is your approximate spend on PSC workers per annum?",
            type: zodQuestionTypes.enum.DropDown,
            values: [
                "Less than £100k",
                "£100k - £500k",
                "Above £500k",
            ],
            flow: {
                next: ConclusionKeys.Red,
            },
        },
    ],
};



export default questionnaireOpwPart1;
